import {
    FormControl,
    Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
    autoCompleteSelectOptionsFormat,
    extractDataGroup,
    extractSelectedValues,
    selectedListValues,
} from "../../../../../utility/helper";
import { listItemProp } from "utility/types";
import MultiSelectAutoCompleteV1 from "shared-component/autocomplete-checkbox-multiple-v1";
import { useState } from "react";

dayjs.extend(utc);

const PartsFilter = (props: any) => {
    const [naOverseas, setNAOverseas] = useState<string[]>(extractDataGroup(props.unNestedParamData, "naOverseas") ?? []);
    const [engineTypeCode, setEngineTypeCode] = useState<string[]>(extractDataGroup(props.unNestedParamData, "engineTypeCode") ?? []);
    const [engineFamilyCode, setEngineFamilyCode] = useState<string[]>(extractDataGroup(props.unNestedParamData, "engineFamilyCode") ?? []);
    const [powerTrainType, setPowerTrainType] = useState<string[]>(extractDataGroup(props.unNestedParamData, "powerTrainType") ?? []);
    const [driveTrainCategory, setDriveTrainCategory] = useState<string[]>(extractDataGroup(props.unNestedParamData, "driveTrainCategory") ?? []);
    const [transmissionType, setTransmissionType] = useState<string[]>(extractDataGroup(props.unNestedParamData, "transmissionType") ?? []);
    const [transmissionModel, setTransmissionModel] = useState<string[]>(extractDataGroup(props.unNestedParamData, "transmissionModel") ?? []);
    const [partNumber, setPartNumber] = useState<string[]>(extractDataGroup(props.unNestedParamData, "partNumber") ?? []);
    const [partName, setPartName] = useState<string[]>(extractDataGroup(props.unNestedParamData, "partName") ?? []);


    const handleSelection = (selectedList: listItemProp[], filter: string) => {
        const value: string[] = selectedListValues(selectedList);
        switch (filter) {
            case 'naOverseas':
                setNAOverseas(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
            case 'engineTypeCode':
                setEngineTypeCode(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
            case 'engineFamilyCode':
                setEngineFamilyCode(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
            case 'powerTrainType':
                setPowerTrainType(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
            case 'driveTrainCategory':
                setDriveTrainCategory(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
            case 'transmissionType':
                setTransmissionType(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
            case 'transmissionModel':
                setTransmissionModel(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
            case 'partNumber':
                setPartNumber(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
            case 'partName':
                setPartName(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;

        }

    }

    return (
        <div style={{ display: "flex", flexWrap: "wrap", paddingTop: "1rem", justifyContent: "flex-start" }}>
        <div className="signalFilterList" style={{ padding: "8px" }}>
            <Tooltip title={naOverseas?.length > 0 ? naOverseas?.toString() : "Select / Search N/A Overseas"} placement="right">
                <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                    <MultiSelectAutoCompleteV1
                        items={autoCompleteSelectOptionsFormat(props?.naOverseas)}
                        label="Select / Search N/A Overseas"
                        selectAllLabel="Select All"
                        onChange={(value: listItemProp[]) => {
                            // if (value?.length > 0) handleCANSignalSelection(value)
                            handleSelection(value, "naOverseas")
                        }}
                        
                        selectedValues={extractSelectedValues(naOverseas)}
                        disabled={props.naOverseas?.length === 0}
                    />
                </FormControl>
            </Tooltip>
        </div>
        <div className="signalFilterList" style={{ padding: "8px" }}>
            <Tooltip title={engineTypeCode?.length > 0 ? engineTypeCode?.toString() : "Select / Search Engine Type Code"} placement="right">
                <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                    <MultiSelectAutoCompleteV1
                        items={autoCompleteSelectOptionsFormat(props?.engineTypeCode)}
                        label="Select / Search Engine Type Code"
                        selectAllLabel="Select All"
                        onChange={(value: listItemProp[]) => {
                            // if (value?.length > 0) handleCANSignalSelection(value)
                            handleSelection(value, "engineTypeCode")
                        }}
                        
                        selectedValues={extractSelectedValues(engineTypeCode)}
                        disabled={props.engineTypeCode?.length === 0}
                    />
                </FormControl>
            </Tooltip>
        </div>

        <div className="signalFilterList" style={{ padding: "8px" }}>
            <Tooltip title={engineFamilyCode?.length > 0 ? engineFamilyCode?.toString() : "Select / Search Engine Family Code"} placement="right">
                <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                    <MultiSelectAutoCompleteV1
                        items={autoCompleteSelectOptionsFormat(props?.engineFamilyCode)}
                        label="Select / Search Engine Family Code"
                        selectAllLabel="Select All"
                        onChange={(value: listItemProp[]) => {
                            // if (value?.length > 0) handleCANSignalSelection(value)
                            handleSelection(value, "engineFamilyCode")
                        }}
                        
                        selectedValues={extractSelectedValues(engineFamilyCode)}
                        disabled={props.engineFamilyCode?.length === 0}
                    />
                </FormControl>
            </Tooltip>
        </div>
        <div className="signalFilterList" style={{ padding: "8px" }}>
            <Tooltip title={powerTrainType?.length > 0 ? powerTrainType?.toString() : "Select / Search Power Train Type"} placement="right">
                <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                    <MultiSelectAutoCompleteV1
                        items={autoCompleteSelectOptionsFormat(props?.powerTrainType)}
                        label="Select / Search Power Train Type"
                        selectAllLabel="Select All"
                        onChange={(value: listItemProp[]) => {
                            // if (value?.length > 0) handleCANSignalSelection(value)
                            handleSelection(value, "powerTrainType")
                        }}
                        
                        selectedValues={extractSelectedValues(powerTrainType)}
                        disabled={props.powerTrainType?.length === 0}
                    />
                </FormControl>
            </Tooltip>
        </div>
        <div className="signalFilterList" style={{ padding: "8px" }}>
            <Tooltip title={driveTrainCategory?.length > 0 ? driveTrainCategory?.toString() : "Select / Search Drive Train Category"} placement="right">
                <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                    <MultiSelectAutoCompleteV1
                        items={autoCompleteSelectOptionsFormat(props?.driveTrainCategory)}
                        label="Select / Search Drive Train Category"
                        selectAllLabel="Select All"
                        onChange={(value: listItemProp[]) => {
                            // if (value?.length > 0) handleCANSignalSelection(value)
                            handleSelection(value, "driveTrainCategory")
                        }}
                        
                        selectedValues={extractSelectedValues(driveTrainCategory)}
                        disabled={props.driveTrainCategory?.length === 0}
                    />
                </FormControl>
            </Tooltip>
        </div>
        <div className="signalFilterList" style={{ padding: "8px" }}>
            <Tooltip title={transmissionType?.length > 0 ? transmissionType?.toString() : "Select / Search Transmission Type"} placement="right">
                <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                    <MultiSelectAutoCompleteV1
                        items={autoCompleteSelectOptionsFormat(props?.transmissionType)}
                        label="Select / Search Transmission Type"
                        selectAllLabel="Select All"
                        onChange={(value: listItemProp[]) => {
                            // if (value?.length > 0) handleCANSignalSelection(value)
                            handleSelection(value, "transmissionType")
                        }}
                        
                        selectedValues={extractSelectedValues(transmissionType)}
                        disabled={props.transmissionType?.length === 0}
                    />
                </FormControl>
            </Tooltip>
        </div>
        <div className="signalFilterList" style={{ padding: "8px" }}>
            <Tooltip title={transmissionModel?.length > 0 ? transmissionModel?.toString() : "Select / Search Transmission Model"} placement="right">
                <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                    <MultiSelectAutoCompleteV1
                        items={autoCompleteSelectOptionsFormat(props?.transmissionModel)}
                        label="Select / Search Transmission Model"
                        selectAllLabel="Select All"
                        onChange={(value: listItemProp[]) => {
                            // if (value?.length > 0) handleCANSignalSelection(value)
                            handleSelection(value, "transmissionModel")
                        }}
                        
                        selectedValues={extractSelectedValues(transmissionModel)}
                        disabled={props.transmissionModel?.length === 0}
                    />
                </FormControl>
            </Tooltip>
        </div>
        <div className="signalFilterList" style={{ padding: "8px" }}>
            <Tooltip title={partNumber?.length > 0 ? partNumber?.toString() : "Select / Search Part Number"} placement="right">
                <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                    <MultiSelectAutoCompleteV1
                        items={autoCompleteSelectOptionsFormat(props?.partNumber)}
                        label="Select / Search Part Number"
                        selectAllLabel="Select All"
                        onChange={(value: listItemProp[]) => {
                            // if (value?.length > 0) handleCANSignalSelection(value)
                            handleSelection(value, "partNumber")
                        }}
                        
                        selectedValues={extractSelectedValues(partNumber)}
                        disabled={props.partNumber?.length === 0}
                    />
                </FormControl>
            </Tooltip>
        </div>
        <div className="signalFilterList" style={{ padding: "8px" }}>
            <Tooltip title={partName?.length > 0 ? partName?.toString() : "Select / Search Part Name"} placement="right">
                <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                    <MultiSelectAutoCompleteV1
                        items={autoCompleteSelectOptionsFormat(props?.partName)}
                        label="Select / Search Part Name"
                        selectAllLabel="Select All"
                        onChange={(value: listItemProp[]) => {
                            // if (value?.length > 0) handleCANSignalSelection(value)
                            handleSelection(value, "partName")
                        }}
                        
                        selectedValues={extractSelectedValues(partName)}
                        disabled={props.partName?.length === 0}
                    />
                </FormControl>
            </Tooltip>
        </div>
    </div>
    );
};



export default PartsFilter;
